import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  background: ${Colours.green};

  h1 {
    font-size: 2rem;
    color: ${Colours.white};
    letter-spacing: -0.12px;
    line-height: 39px;
    font-weight: 400;
  }
`;
